var _circle, _g, _path, _path2, _path3, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElSalvador(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#f0f0f0",
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0052b4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-101.494 0-189.19 59.065-230.598 144.696h461.195c-41.407-85.631-129.104-144.696-230.597-144.696z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 512c101.493 0 189.19-59.065 230.598-144.696h-461.196c41.408 85.631 129.104 144.696 230.598 144.696z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m204.59 267.13 51.41-89.043 51.41 89.043z",
    fill: "#ffda44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m322.783 296.531-66.783 33.392-66.783-33.392v-44.521h133.566z",
    fill: "#6da544"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m318.963 181.907-23.611 23.611c10.071 10.071 16.301 23.984 16.301 39.352 0 30.736-24.917 55.652-55.652 55.652s-55.652-24.917-55.652-55.652c0-15.368 6.23-29.281 16.301-39.352l-23.611-23.611c-16.115 16.112-26.081 38.373-26.081 62.963 0 49.178 39.866 89.043 89.043 89.043s89.043-39.866 89.043-89.043c-.001-24.59-9.967-46.851-26.081-62.963z",
    fill: "#ffda44"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElSalvador);
export default __webpack_public_path__ + "static/media/elSalvador.8c2ae0b052d1aac0281a6b1566222b69.svg";
export { ForwardRef as ReactComponent };